import eventStore from './store'

export default class EventModule {
  name = 'event'
  constructor({ store }) {
    store.registerModule(this.name, eventStore)
  }
}
